<template>
  <div>
    <div   style="top: 50% !important;" class="md-dialog upload-doc md-theme-default" md-active="true">
      <div class="md-dialog-container" tabindex="-1">
        <div class="md-dialog-content md-theme-default">
          <span class="popup-title">
            DEPOSIT COMPLIANCE STATEMENT:
            <br />
            LICENCE #{{now}}
          </span>
           <span class="float-right cursor-pointer" @click="$emit('cancel')">
            <md-icon class="md-size-1x">close</md-icon>
          </span>
          <span
            class="popup-text mt-4"
          >I hereby certify that (a) I have reviewed the transaction activity set forth in the attached depos-it; and (b) the deposit complies with all applicable federal and state laws and regulations, and meets the DEPOSITORY’s specific deposit criteria.</span>
          <div>
            <md-radio v-model="radio1" class="md-primary" value="1">Accept</md-radio>
            <md-radio v-model="radio1" class="md-primary" value="0">Dont Accept</md-radio>
          </div>
          <span class="popup-title">
            OFAC COMPLIANCE STATEMENT:
            <br />
            LICENSE #{{now}}
          </span>
          <span
            class="popup-text mt-4"
          >I hereby certify that the attached items for deposit comply with all OFAC regulations and I hereby certify that I am complying with all OFAC regulations including (a) blocking accounts and other property of specified countries, entities and individuals and (b) prohibiting and rejecting unlicensed financial transactions with specified countries, entities and individuals.</span>
          <div>
            <md-radio v-model="radio2" class="md-primary" value="1">Accept</md-radio>
            <md-radio v-model="radio2" class="md-primary" value="0">Dont Accept</md-radio>
          </div>
        </div>
        <div class="md-dialog-actions pr-5 pb-3">
          <md-button @click="$emit('cancel')" class="md-primary">Cancel</md-button>
          <md-button
            @click="clicked=1,$emit('confirm')"
            :disabled="isDisable"
            class="md-button md-primary md-raised c-primary pl-2 md-theme-default"
          >Confirm</md-button>
        </div>
      </div>
    </div>
    <div class="md-overlay md-fixed md-dialog-overlay"></div>
  </div>
</template>
<script>
import format from "date-fns/format";
export default {
  props: ["single", "type"],
  data() {
    return {
      doc: "",
      dateFormat: "yyyy-MM-dd",
      renewal: format(new Date(), "yyyy-MM-dd"),
      state: "",
      values: "",
      clicked:0,
      now: format(new Date(), "dd - MMM - yyyy"),
      radio1: 0,
      radio2: 0
    };
  },
  created() {
    //load the states for filling the select box
    axios.get("/states").then(({ data }) => {
      this.values = data.states;
    });
  },
  methods: {
    upload() {
      this.$emit("update", {
        doc: this.doc,
        renewal: this.renewal,
        state: this.state
      });
    },
    previewFiles(event) {
      this.doc = this.$refs.file.files[0];
    }
  },
  computed: {
    isDisable() {
      if (!this.clicked && this.radio1 == "1" && this.radio2 == "1") {
        return false;
      } else return true;
    }
  }
};
</script>